import { render, staticRenderFns } from "./MainMine.vue?vue&type=template&id=0f170680&scoped=true&"
import script from "./MainMine.vue?vue&type=script&lang=ts&"
export * from "./MainMine.vue?vue&type=script&lang=ts&"
import style1 from "./MainMine.vue?vue&type=style&index=1&id=0f170680&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f170680",
  null
  
)

export default component.exports